// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infos {
  padding: 0.2rem 1rem;
  text-align: justify;
  font-size: 1rem;
  font-weight: 600;
  color: rgb(231, 39, 39);
}

.infos1 {
  padding: 0.2rem 1rem;
  text-align: justify;
  font-size: 1rem;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/pages/Hosts/Search.scss"],"names":[],"mappings":"AAEA;EACI,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AADJ;;AAGA;EACI,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAAJ","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/globals';\n.infos{\n    padding: 0.2rem 1rem;\n    text-align: justify;\n    font-size: 1rem;\n    font-weight: 600;\n    color: rgb(231, 39, 39);\n}\n.infos1{\n    padding: 0.2rem 1rem;\n    text-align: justify;\n    font-size: 1rem;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
